import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, addReactError } from '@datadog/browser-rum-react';
import App from './App.tsx';
import { GlobalErrorFallback } from './components/ErrorFallback';
import { initDatadog } from './utils/datadog';

// Initialize Datadog RUM (reads from env vars)
initDatadog();

const container = document.getElementById('root')!;

// React 19 error handling with Datadog integration
const root = createRoot(container, {
  onUncaughtError: (error, errorInfo) => {
    // Report uncaught errors to Datadog
    addReactError(error as Error, errorInfo);
    console.error('Uncaught error:', error, errorInfo);
  },
  onCaughtError: (error, errorInfo) => {
    // Report caught errors to Datadog
    addReactError(error as Error, errorInfo);
    console.error('Caught error:', error, errorInfo);
  },
  onRecoverableError: (error, errorInfo) => {
    // Report recoverable errors to Datadog (e.g., hydration mismatches)
    addReactError(error as Error, errorInfo);
    console.warn('Recoverable error:', error, errorInfo);
  },
});

root.render(
  <StrictMode>
    <ErrorBoundary fallback={GlobalErrorFallback}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
